<template>
  <span
    class="absolute bottom-2 right-3 text-xxs transition-colors"
    :class="contentLength > maxLength ? 'text-red-400' : 'text-gray-400'"
  >
    {{ contentLength || '0' }}/{{ maxLength }}
  </span>
</template>

<script>
export default {
  name: 'CharacterCount',
  props: {
    section: {
      type: String,
    },
    maxLength: {
      type: Number,
    },
  },
  computed: {
    contentLength() {
      return this.section?.replace(/(<([^>]+)>)/gi, '').length;
    },
  },
};
</script>

<style scoped></style>
